import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import makeStyles from '@mui/styles/makeStyles';

import { ActionButtons } from "components/ActionButtons";
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GridCloseIcon } from '@mui/x-data-grid';


const useStyles = makeStyles({
  paper: {
    borderRadius: 8,
    padding: 8,
  }
});


export function ConfirmationDialog({
  open,
  onPrimaryClick,
  onSecondaryClick,
  primaryActionVariant,
  secondaryActionVariant,
  title = "Confirm",
  message = "Are you sure?",
  multipleMessage = null,
  primaryAction = "Yes",
  secondaryAction = "No",
}) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onSecondaryClick}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: classes.paper }}
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{ m: 0, p: theme.spacing(0,5,0,5) }}
      >
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='h5-medium'>
            {title}
          </Typography>
          <IconButton onClick={onSecondaryClick}>
            <GridCloseIcon/>
          </IconButton>
        </Box>
        <Divider/>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 380, maxWidth :500 , mt: 4, p: theme.spacing(5) }}>
        <DialogContentText>
          {
            multipleMessage ?
              <Box display='flex' flexDirection='column' gap='10px'>
              {
                multipleMessage.map((data)=>{
                  return (
                    <Typography variant='h6-regular' color='#000'>
                    {data}
                  </Typography>
                  )
                })
              }
              </Box>
              :  <Typography variant='h5-regular' >
                  {message}
                </Typography>
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ActionButtons
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
          onSecondaryClick={onSecondaryClick}
          onPrimaryClick={onPrimaryClick}
          primaryActionVariant={primaryActionVariant}
          secondaryActionVariant={secondaryActionVariant}
          width="100%"
        />
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;